// App.js
import { useEffect, useState } from "react";
import { Routes, Route, useLocation } from "react-router-dom";
import { HelmetProvider } from "react-helmet-async";

import Home from "./Pages/Home";
import Contact from "./Pages/Contact";
import Booknow from "./Pages/Booknow";
import Error from "./Pages/Error";
import Header from "./Components/Header";
import Footer from "./Components/Footer";
import Loader from "./Components/Loader";
import BecomeSpeaker from "./Pages/BecomeSpeaker";
import BenefitsSpeaker from "./Pages/BenefitsSpeaker";
import BecomeSponsor from "./Pages/BecomeSponsor";
import Checkout from "./Components/Checkout";
import Terms from "./Pages/Terms/Terms";
import Agenda from "./Pages/Agenda";

function App() {
  const location = useLocation();
  const hideHeaderFooter = location.pathname === "/Comingsoon";
  const [loading, setLoading] = useState(true);

  useEffect(() => {
    const timer = setTimeout(() => setLoading(false), 1000);
    return () => clearTimeout(timer);
  }, []);

  useEffect(() => {
    setLoading(true);
    const timer = setTimeout(() => setLoading(false), 800);
    return () => clearTimeout(timer);
  }, [location]);

  return (
    <HelmetProvider>
      {loading && <Loader />}
      <div>
        {!hideHeaderFooter && <Header />}
        <Routes>
          <Route path="/" element={<Home />} />
           <Route path="/agenda" element={<Agenda />} />
          <Route path="/contact" element={<Contact />} />
          <Route path="/booknow" element={<Booknow />} />
          <Route path="*" element={<Error />} />
          <Route path="/becomespeaker" element={<BecomeSpeaker />} />
          <Route path="/speakerbenefits" element={<BenefitsSpeaker />} />
          <Route path="/sponsors" element={<BecomeSponsor />} />
          <Route path="/checkout" element={<Checkout />} />
          <Route path="/terms" element={<Terms />} />
        </Routes>
        {!hideHeaderFooter && <Footer />}
      </div>
    </HelmetProvider>
  );
}

export default App;
